// Alle Werte des PRODUCTS-Enums (Backend schema.graphql) mit Titel und
// Beschreibung für das Produktgrid der Payment-Seite. Beschreibungen kommen,
// wo es eine gibt, aus den Tooltips der LP-Preismatrix (lp.pricing.matrix,
// aivy-dashboard-landingpage origin/production 23eb713), neutral formuliert.
// Ob ein Produkt im Preismodell steckt, entscheidet MANAGED_PRODUCTS aus dem
// Katalog, nicht diese Datei.
import { MANAGED_PRODUCTS } from './pricing-catalog'

export const PRODUCTS = {
  ATTRACT: {
    title: 'Orientierungsmodul (Attract)',
    description:
      'Zeigt Talenten auf der Karriereseite oder bei Events, welche offenen Stellen am besten zu ihnen passen.'
  },
  SKILLCHECK: {
    title: 'Skillcheck',
    description:
      'Altprodukt außerhalb des Preismodells. Ein Paket lässt den Wert unverändert.'
  },
  CUSTOMIZE_UI: {
    title: 'Oberfläche anpassen',
    description:
      'Altprodukt außerhalb des Preismodells. Ein Paket lässt den Wert unverändert.'
  },
  API: {
    title: 'Custom API',
    description:
      'REST-Schnittstelle für die Anbindung an eigene Systeme und Workflows. API-Keys gibt es auch mit Partner-ATS-Integration oder ATS-Plugin, weil derselbe Key die ATS-Anbindungen authentifiziert.'
  },
  BRANDING: {
    title: 'Branding individuell',
    description: 'Farben, Bilder und Texte im eigenen CI.'
  },
  BRANDING_BASIC: {
    title: 'Branding Basic',
    description: 'Logo und Grundfarben.'
  },
  TALENTPOOL: {
    title: 'Talentpool und Initiativbewerbungen',
    description: 'Eigener Weg für Talente ohne konkrete Stellenbewerbung.'
  },
  SMARTPREDICT: {
    title: 'Datengetriebene Anforderungsanalyse (Smart-Predict)',
    description:
      'Idealtypische Mitarbeitende durchlaufen das Assessment. Das Anforderungsprofil entsteht aus echten Erfolgsmustern und verbessert sich mit jeder Besetzung.'
  },
  FAKINGMODULE: {
    title: 'Faking-Modul',
    description:
      'Altprodukt außerhalb des Preismodells. Ein Paket lässt den Wert unverändert.'
  },
  INTERVIEWPAPER: {
    title: 'Interviewleitfaden',
    description:
      'Interviewfragen, die aus dem individuellen Stärkenprofil der Person entstehen.'
  },
  BROWSERPLUGIN: {
    title: 'ATS-Plugin (Browser-Plugin)',
    description:
      'Anbindung an das Bewerbermanagement über das Aivy-Plugin, unabhängig davon, welches System der Kunde nutzt. In Start zubuchbar.'
  },
  PUBLICINVITATIONLINK: {
    title: 'Öffentlicher Einladungslink',
    description:
      'Talente lassen sich über einen öffentlichen Link zum Assessment einer Stelle einladen.'
  },
  REDIRECTTALENTURL: {
    title: 'Weiterleitung nach dem Assessment',
    description:
      'Bewerbende landen nach dem Assessment automatisch auf einer Seite nach Wahl des Kunden, zum Beispiel zurück im Bewerbungsformular.'
  },
  CROSSCOMPARISON: {
    title: 'Kreuzmatching',
    description:
      'Talente können jederzeit auf alle Anforderungsprofile gematcht und miteinander verglichen werden, auch nachträglich.'
  },
  INTEGRATIONS: {
    title: 'Partner-ATS-Integration',
    description:
      'Tiefe, native Anbindung an Partnersysteme wie softgarden, Personio oder Workday, ohne Plugin.'
  },
  AUTOMATIONS: {
    title: 'DSGVO-Automatisierung',
    description:
      'Talentdaten werden nach der gesetzten Frist automatisch gelöscht. Ohne gültiges Payment mit diesem Produkt plant das Backend keine Löschungen mehr ein.'
  },
  TEAM_ANALYSIS: {
    title: 'Teamanalyse',
    description:
      'Zeigt, wie sich die Stärken im Team ergänzen und wo etwas fehlt.'
  },
  TEAM_ANALYSIS_BASIC: {
    title: 'Teamanalyse Basic',
    description:
      'Altprodukt außerhalb des Preismodells. Ein Paket lässt den Wert unverändert.'
  },
  PERMISSION_SYSTEM: {
    title: 'Berechtigungssystem',
    description:
      'Rollenbasierte Rechte. Der Kunde legt fest, wer was sieht und wer was ändern darf.'
  },
  SUB_COMPANIES: {
    title: 'Unterdashboards',
    description:
      'Eigene Dashboards für Standorte, Teams oder Fachbereiche innerhalb eines Accounts.'
  },
  CUSTOM_REPORTS: {
    title: 'Anpassbare Ergebnisreports',
    description: 'Aufbau und Inhalt der Reports an die Anforderungen anpassen.'
  },
  LANGUAGE_FR: {
    title: 'Assessment auf Französisch',
    description:
      'Talente durchlaufen das Assessment neben Deutsch und Englisch auch auf Französisch.'
  },
  LANGUAGE_NL: {
    title: 'Assessment auf Niederländisch',
    description:
      'Talente durchlaufen das Assessment neben Deutsch und Englisch auch auf Niederländisch.'
  }
}

// Reihenfolge wie im Enum
export const PRODUCT_KEYS = Object.keys(PRODUCTS)

// Kommen erst mit dem Schema-Deploy (Backend feat/payment-plan). Ohne
// Schema-Probe gelten sie als nicht verfügbar.
export const NEW_PRODUCTS = ['CUSTOM_REPORTS', 'LANGUAGE_FR', 'LANGUAGE_NL']

// Die 20 Werte, die jede Stage schon vor dem Preismodell kannte
export const LEGACY_SCHEMA_PRODUCTS = PRODUCT_KEYS.filter(
  (key) => !NEW_PRODUCTS.includes(key)
)

export const PRODUCT_GROUPS = {
  PRICING: { id: 'pricing', label: 'Im Preismodell' },
  OTHER: { id: 'other', label: 'Weitere Produkte' },
  UNKNOWN: { id: 'unknown', label: 'Unbekannte Werte' }
}

export const isKnownProduct = (key) =>
  Object.prototype.hasOwnProperty.call(PRODUCTS, key)

export const isManagedProduct = (key) => MANAGED_PRODUCTS.includes(key)

export const productTitle = (key) =>
  isKnownProduct(key) ? PRODUCTS[key].title : String(key)

export const productDescription = (key) =>
  isKnownProduct(key) ? PRODUCTS[key].description : ''

/**
 * Teilt Produkte in die Gruppen des Grids. „Im Preismodell" sind die
 * verwalteten Produkte in der Reihenfolge des Katalogs, „Weitere Produkte"
 * alle übrigen bekannten in Enum-Reihenfolge. Werte, die diese Datei nicht
 * kennt (etwa von einem Payment), landen unter „Unbekannte Werte". Leere
 * Gruppen fallen weg.
 *
 * @param {string[]} [keys] Standard sind alle bekannten Produkte
 * @returns {{ id: string, label: string, products: string[] }[]}
 */
export const groupProducts = (keys = PRODUCT_KEYS) => {
  const list = [...new Set((keys || []).filter(Boolean))]
  const pricing = MANAGED_PRODUCTS.filter((key) => list.includes(key))
  const other = PRODUCT_KEYS.filter(
    (key) => list.includes(key) && !isManagedProduct(key)
  )
  const unknown = list.filter((key) => !isKnownProduct(key))

  return [
    { ...PRODUCT_GROUPS.PRICING, products: pricing },
    { ...PRODUCT_GROUPS.OTHER, products: other },
    { ...PRODUCT_GROUPS.UNKNOWN, products: unknown }
  ].filter(({ products }) => products.length > 0)
}

// Sortiert nach Enum-Reihenfolge, unbekannte Werte ans Ende
export const sortProducts = (keys) => {
  const rank = (key) => {
    const index = PRODUCT_KEYS.indexOf(key)
    return index === -1 ? PRODUCT_KEYS.length : index
  }

  return [...new Set((keys || []).filter(Boolean))].sort(
    (a, b) => rank(a) - rank(b) || String(a).localeCompare(String(b))
  )
}
